import { ILoadingScreen } from "@babylonjs/core/Loading/loadingScreen";


export class LoadingScreen implements ILoadingScreen {
  //optional, but needed due to interface definitions
  public loadingUIBackgroundColor: string = '#000';
  constructor(public loadingUIText: string) {}

  public displayLoadingUI() {
    // TODO: Add a logo or spinner
  }

  public hideLoadingUI() {
    // TODO: Nide loader UI
  }
}